module.exports = __webpack_public_path__ + "static/media/contract_icon_quick_books.79a7e75f.svg";